const phoneService = {
  search: {
    serialNumber: "Numéro de série",
    orderNumber: "Numéro de CMD",
    quoteNumber: "Numéro de devis",
    productName: "Nom du produit",
    price: "Prix",
    state: "Etat",
    partner: "Client",
    client: "Compte client",
    place: "Site",
    productFamily: "Famille de produit",
    productSubFamily: "Sous-famille de produit",
    deliveryDateTimeframe: "Plage de temps / Livraison",
    deliveryDateMin: "Livré après",
    deliveryDateMax: "Livré avant",
    updateDateTimeframe: "Plage de temps / MàJ",
    updateDateMin: "Mise à jour après",
    updateDateMax: "Mise à jour avant",
    emptyApiKey: "Clé d'API vide",
    consumptionDate: "Date"
  },
};

export default phoneService;
